// Icones das abas Identificacao e Localizacao (pedido dela, 28/09), no mesmo
// estilo de IconesDaPolitica -- SVG inline de linha, sem biblioteca nova.
type P = { tamanho?: number }
const base = (t: number) => ({
  viewBox: '0 0 24 24', width: t, height: t, fill: 'none', stroke: 'currentColor',
  strokeWidth: 1.8, strokeLinecap: 'round' as const, strokeLinejoin: 'round' as const, 'aria-hidden': true,
})
export function IconeCasa({ tamanho = 18 }: P) {
  return <svg {...base(tamanho)}><path d="M3 11l9-7 9 7M5 10v10h14V10M10 20v-6h4v6" /></svg>
}
export function IconeTelefone({ tamanho = 18 }: P) {
  return <svg {...base(tamanho)}><path d="M5 4h4l2 5-2.5 1.5a11 11 0 005 5L15 13l5 2v4a2 2 0 01-2 2A16 16 0 013 6a2 2 0 012-2z" /></svg>
}
export function IconeWhats({ tamanho = 18 }: P) {
  return <svg {...base(tamanho)}><path d="M4 20l1.3-3.9A8 8 0 1112 20a8 8 0 01-4-1.1z" /><path d="M9 9.5c0 3 2.5 5.5 5.5 5.5l1-1.5-2-1-1 .8a4 4 0 01-1.8-1.8l.8-1-1-2z" /></svg>
}
export function IconeEmail({ tamanho = 18 }: P) {
  return <svg {...base(tamanho)}><rect x="3" y="5" width="18" height="14" rx="2" /><path d="M3 7l9 6 9-6" /></svg>
}
export function IconePessoa({ tamanho = 18 }: P) {
  return <svg {...base(tamanho)}><circle cx="12" cy="8" r="4" /><path d="M4 21a8 8 0 0116 0" /></svg>
}
export function IconeLink({ tamanho = 18 }: P) {
  return <svg {...base(tamanho)}><path d="M10 14a4 4 0 005.7 0l3-3a4 4 0 00-5.7-5.7l-1 1M14 10a4 4 0 00-5.7 0l-3 3a4 4 0 005.7 5.7l1-1" /></svg>
}
export function IconeInstagram({ tamanho = 18 }: P) {
  return <svg {...base(tamanho)}><rect x="3" y="3" width="18" height="18" rx="5" /><circle cx="12" cy="12" r="4" /><circle cx="17.5" cy="6.5" r="0.8" /></svg>
}
export function IconeAnotacao({ tamanho = 18 }: P) {
  return <svg {...base(tamanho)}><path d="M6 3h9l4 4v14H6zM14 3v5h5M9 13h7M9 17h5" /></svg>
}
export function IconeLupa({ tamanho = 18 }: P) {
  return <svg {...base(tamanho)}><circle cx="11" cy="11" r="7" /><path d="M20 20l-4-4" /></svg>
}
